export function resolveSpanish(country: string | undefined, naCountry: string) {
  switch (country) {
    case 'ES': // Spain
    case 'ES_tradnl': // Spain (Castilian)
      return 'es-ES';
    case 'AR': // Argentina
    case 'BO': // Bolivia
    case 'CL': // Chile
    case 'CO': // Colombia
    case 'CR': // Costa Rica
    case 'DO': // Dominican Republic
    case 'EC': // Ecuador
    case 'GT': // Guatemala
    case 'HN': // Honduras
    case 'MX': // Mexico
    case 'XL': // Latin America
    case 'NI': // Nicaragua
    case 'PA': // Panama
    case 'PE': // Peru
    case 'PR': // Puerto Rico
    case 'PY': // Paraguay
    case 'SV': // El Salvador
    case 'UY': // Uruguay
    case 'VE': // Venezuela
    case 'US': // United States
      return 'es-US';
    default:
      if (checkNaCountry(naCountry)) {
        return 'es-ES';
      } else {
        return 'es-US';
      }
  }
}

export function resolveEnglish(country: string | undefined, naCountry: string) {
  switch (country) {
    case 'US': // United States
    case 'CA': // Canada
    case 'JM': // Jamaica
    case 'BZ': // Belize
    case 'TT': // Trinidad and Tobago
    case 'PH': // Philippines
    case 'CB': // Curaçao
      return 'en-US';
    case 'GB': // United Kingdom
    case 'AU': // Australia
    case 'NZ': // New Zealand
    case 'IE': // Ireland
    case 'ZA': // South Africa
    case 'ZW': // Zimbabwe
    case 'ID': // Indonesia
    case 'HK': // Hong Kong
    case 'IN': // India
    case 'MY': // Malaysia
    case 'SG': // Singapore
      return 'en-GB';
    default:
      if (checkNaCountry(naCountry)) {
        return 'en-GB';
      } else {
        return 'en-US';
      }
  }
}

export function resolveFrench(country: string | undefined, naCountry: string) {
  switch (country) {
    case 'CA': // Canada
      return 'fr-CA';
    case 'FR': // France
    case 'BE': // Belgium
    case 'CH': // Switzerland
    case 'LU': // Luxembourg
    case 'MC': // Monaco
    case 'RE': // Réunion
    case 'CG': // Congo (Rebublic of the Congo)
    case 'CD': // Congo (Democratic Rebublic of the Congo)
    case 'SN': // Senegal
    case 'CM': // Cameroon
    case 'CI': // Côte d'Ivoire
    case 'ML': // Mali
    case 'MA': // Morocco
    case 'HT': // Haiti
      return 'fr-FR';
    default:
      if (checkNaCountry(naCountry)) {
        return 'fr-FR';
      } else {
        return 'fr-CA';
      }
  }
}

export function resolveChinese(country: string | undefined, naCountry: string) {
  switch (country) {
    case 'CN': // China
    case 'SG': // Singapore
    case 'Hans': // Han (Simplified variant)
      return 'zh-CN';
    case 'TW': // Taiwan
    case 'HK': // Hong Kong
    case 'MO': // Macao
    case 'Hant': // Han (Traditional variant)
      return 'zh-TW';
    default:
      return 'zh-TW';
  }
}

function checkNaCountry(naCountry: string) {
  switch (naCountry) {
    case 'IE': // Ireland
    case 'GB': // United Kingdom
    case 'IL': // Israel
    case 'IT': // Italy
    case 'EE': // Estonia
    case 'AU': // Australia
    case 'AT': // Austria
    case 'NL': // Netherlands
    case 'CY': // Cyprus
    case 'GR': // Greece
    case 'HR': // Croatia
    case 'CH': // Switzerland
    case 'SE': // Sweden
    case 'ES': // Spain
    case 'SK': // Slovakia
    case 'SI': // Slovenia
    case 'CZ': // Czech Republic
    case 'DK': // Denmark
    case 'DE': // Germany
    case 'NZ': // New Zealand
    case 'NO': // Norway
    case 'HU': // Hungary
    case 'FI': // Finland
    case 'FR': // France
    case 'BG': // Bulgaria
    case 'BE': // Belgium
    case 'PL': // Poland
    case 'PT': // Portugal
    case 'MT': // Malta
    case 'LV': // Latvia
    case 'LT': // Lithuania
    case 'RO': // Romania
    case 'LU': // Luxembourg
    case 'RU': // Russia
    case 'ZA': // South Africa
      return true;
    default:
      return false;
  }
}
